import React from 'react';
import Icon from '../Icon';
import clsx from 'clsx';

const MegaMenuColumn = ({ link, onLinkEnter, columnIndex, activeLinks }) => {
  return (
    <div className="mega-menu__column">
      {link.links.map((subLink, idx) => (
        <a
          href={subLink.url}
          className={clsx(
            'mega-menu__column-link',
            activeLinks.includes(subLink) && 'mega-menu__column-link--active'
          )}
          key={`${link.name}-columns-link-${idx}`}
          onMouseEnter={() => onLinkEnter(subLink, columnIndex)}
        >
          <span className="mega-menu__link-name">{subLink.name}</span>
          {!!subLink.links.length && (
            <Icon
              name="Caret-Right"
              size={20}
              className="mega-menu__link-icon"
            />
          )}
        </a>
      ))}
    </div>
  );
};

export default MegaMenuColumn;
